import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ className = "w-10 h-10" }) => {
  return (
    <motion.div whileHover={{ scale: 1.05, rotate: [0, -5, 5, 0] }} className={`${className} relative flex items-center justify-center`}>
      <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full drop-shadow-sm">
        <path d="M50 10L15 30V70L50 90L85 70V30L50 10Z" fill="url(#logo-gradient)" />
        <path d="M50 10L15 30L50 50L85 30L50 10Z" fill="white" fillOpacity="0.2" />
        <path d="M35 45V65M35 45L50 55L65 45V65" stroke="white" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        <defs>
          <linearGradient id="logo-gradient" x1="15" y1="10" x2="85" y2="90" gradientUnits="userSpaceOnUse">
            <stop stopColor="#16a34a" /> <stop offset="1" stopColor="#2563eb" />
          </linearGradient>
        </defs>
      </svg>
      <span className="absolute -top-1 -right-1 flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500 border border-white"></span>
      </span>
    </motion.div>
  );
};

export default Logo;